import { Box, Portal, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import theme from '../../muiTheme';
import ChatView from '../ChatView/ChatView';
import Notifications from '../Notifications/Notifications';
import UserAvatar from '../UserAvatar/UserAvatar';

const ChatUI = () => {

    //notifications are obtained from redux store and displayed for about 5 seconds each

    const {chatNotifications, showChat} = useSelector((state) => state.chatUIReducer);



    return (

        <>

            {
                (
                    showChat
                ) &&
                <Portal>


                    
                    <ChatView />
                        
                        

                </Portal>

            }

        </>
        
    ); 
}

export default ChatUI; 